import { timeZoneMap } from "@web-app/utils/helpers";

export enum TimeFormat {
  hour_minute = "HH:mm",
  hour_minute_tz = "HH:mm z",
  hour_minute_am_pm = "hh:mm A",
  hour_minute_am_pm_tz = "hh:mm A z",
  month_day_year = "MM/DD/YYYY",
  month_day_year_tz = "MM/DD/YYYY z",
  month_day_year_hour_minute_am_pm = "MMMM DD, YYYY, hh:mm A",
  month_day_year_hour_minute_am_pm_tz = "MMMM DD, YYYY, hh:mm A z",
  month_day_year_hour_minute = "MMM DD, YYYY HH:mm",
  month_day_year_hour_minute_tz = "MMM DD, YYYY HH:mm z",
  month_day_year_hour_minute_second_am_pm = "MMMM DD, YYYY, hh:mm:ss A",
  month_day_year_hour_minute_second_am_pm_tz = "MMMM DD, YYYY, hh:mm:ss A z",
}

type PopupPositionType = "left" | "right" | "top";
export type TimezoneType = keyof typeof timeZoneMap;

type BaseDateTimeTzProps = {
  timezone?: TimezoneType;
};

type FlatDateTimeTzProps = BaseDateTimeTzProps & {
  end: Date;
  popupPosition?: PopupPositionType;
  presentation: "flat";
  showIcon?: boolean;
  start: Date;
};

type ColumnedDateTimeTzProps = BaseDateTimeTzProps & {
  popupPosition?: PopupPositionType;
  presentation: "columned";
  start: Date;
};

type EtaDateTimeTzProps = BaseDateTimeTzProps & {
  presentation: "eta";
  start: Date;
};

type TimelineDateTimeTzProps = BaseDateTimeTzProps & {
  createdBy?: string;
  isTrackingPage?: boolean;
  presentation: "timeline";
  start: Date;
};

type TrackingPageDateTimeTzProps = BaseDateTimeTzProps & {
  popupPosition?: PopupPositionType;
  presentation: "trackingPage";
  start: Date;
};

type DefaultDateTimeTzProps = BaseDateTimeTzProps & {
  includeSeconds?: boolean;
  popupPosition?: PopupPositionType;
  presentation: "default";
  start: Date;
};

type TrackingPageTimelineDateTimeTzProps = BaseDateTimeTzProps & {
  presentation: "trackingPageTimeline";
  start: Date;
};

type FilterDateTimeTzProps = BaseDateTimeTzProps & {
  end: Date;
  isDateRange?: boolean;
  presentation: "filter";
  start: Date;
};

type PillDateTimeTzProps = BaseDateTimeTzProps & {
  end: Date;
  isDateRange?: boolean;
  presentation: "pill";
  start: Date;
};

export type DateTimeTzProps =
  | ColumnedDateTimeTzProps
  | DefaultDateTimeTzProps
  | EtaDateTimeTzProps
  | FilterDateTimeTzProps
  | FlatDateTimeTzProps
  | PillDateTimeTzProps
  | TimelineDateTimeTzProps
  | TrackingPageDateTimeTzProps
  | TrackingPageTimelineDateTimeTzProps;
